export function registerServiceWorker(onUpdate: () => void) {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
                registration.onupdatefound = () => {
                    const installingWorker = registration.installing;
                    if (!installingWorker) return;

                    installingWorker.onstatechange = () => {
                        if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            onUpdate();
                        }
                    };
                };
            })
            .catch((error) => {
                console.error('Service Worker registration failed:', error);
            });

        navigator.serviceWorker.addEventListener('controllerchange', () => {
            window.location.reload();
        });
    }
}
// export function register(onUpdate: (registration: ServiceWorkerRegistration) => void) {
//     if ('serviceWorker' in navigator) {
//         window.addEventListener('load', () => {
//             navigator.serviceWorker
//                 .register('/service-worker.js')
//                 .then((registration) => {
//                     registration.onupdatefound = () => {
//                         const installingWorker = registration.installing;
//                         if (installingWorker) {
//                             installingWorker.onstatechange = () => {
//                                 if (installingWorker.state === 'installed') {
//                                     if (navigator.serviceWorker.controller) {
//                                         // نسخه جدید در دسترس است، تابع onUpdate را فراخوانی می‌کنیم
//                                         onUpdate(registration);
//                                     }
//                                 }
//                             };
//                         }
//                     };
//                 })
//                 .catch((error) => {
//                     console.error('Service Worker registration failed:', error);
//                 });
//         });
//     }
// }

// export function unregister() {
//     if ('serviceWorker' in navigator) {
//         navigator.serviceWorker.ready.then((registration) => {
//             registration.unregister();
//         });
//     }
// }